export { P125MyProfilePage as default } from './components/P125MyProfilePage';
